<template lang="pug">
  .order-obj
    .order-obj__img
      img(src="@/assets/images/bg/image.png" alt="Заявка")
    .order-obj__main
      .order-obj__meta
        .order-obj__status
          .status(
            :class="statusOptions[order.current_status.status].class"
          ) {{ statusOptions[order.current_status.status].text }}
        .order-obj__data
          .order-obj__id # {{ order.id }}
          .order-obj__date {{ order.date_created | simpleDate }}
      h2.order-obj__title {{ order.event.title }}
      .order-obj__info-container
        .order-obj__info
          .order-obj__period {{ order.event.date_time | simpleDate }}
          .order-obj__name {{ order.user.last_name }} {{ order.user.first_name }} {{ order.user.fathers_name }}
        //- статус новая и резерв
        .order-obj__buttons(
          v-if="showCancelButton"
        )
          button.button(
            @click.prevent="showUserOrderModal(order.id)"
          ) Отменить
        //- статус подтверждена
        .order-obj__buttons(
          v-if="order.current_status.status === 3"
        )
          a.button(
            :href="downloadFileUrl"
            download
          ) Скачать билет
        //- статус отклонена оператором
        .order-obj__buttons(
          v-if="order.current_status.status === 5"
        )
          button.button(
            @click.prevent.stop="toggleReason"
          ) Детали
        .order-obj__details
          rejected-reason(
          v-if="showReason"
          @close="showReason = false"
          :order="order"
          )
</template>

<script>
import { mapActions } from "vuex";
import RejectedReason from "./rejected-reason";
export default {
  name: "order-obj",
  components: { RejectedReason },
  props: ["order"],
  data() {
    return {
      showReason: false,
      statusOptions: {
        1: {
          text: "Новая",
          class: "new",
        },
        2: {
          text: "В работе",
          class: "in_work",
        },
        3: {
          text: "Подтверждена",
          class: "confirmed",
        },
        4: {
          text: "Резерв",
          class: "accepted",
        },
        5: {
          text: "Отклонена",
          class: "rejected_by_operator",
        },
        6: {
          text: "Закрыта",
          class: "accepted",
        },
        7: {
          text: "Отменена",
          class: "rejected_by_user",
        },
        8: {
          text: "Посетил мероприятие",
          class: "confirmed",
        },
      },
    };
  },
  computed: {
    showCancelButton() {
      let statusCodes = [1, 2, 4];
      let value = statusCodes.find(
        (item) => item === this.order.current_status.status
      );
      return value;
    },
    downloadFileUrl() {
      return this.order.ticket_info.download_url;
    },
  },
  methods: {
    ...mapActions(["getOrder"]),
    showUserOrderModal(id) {
      this.$emit("delete", id);
    },
    toggleReason() {
      this.showReason = !this.showReason;
    },
  },
};
</script>
